import React, { Component } from 'react';
import Header from '../../components/Header'
import './forgotpassword.css';
import TextField from '@material-ui/core/TextField';
import Info from '../../components/Info';
import { Link } from 'react-router-dom';

class ForgotPassword extends Component {

    componentDidMount(){
        window.scrollTo(0, 0)
    }

    render(){
        document.title = 'Esqueci minha senha'
        return(
            <div className="overflow-hidden">
                <Header/>
                <div className="row ">
                    <div className="col-6 blueBgRegister bgDivSettings p-5">
                        <div className="row">
                            <div className="col-8 mt-5 ml-5">
                                <p className="questionRegister m-0">Esqueceu sua senha?</p>
                                <p className="guideRegister mt-3">Você pode recuperar sua senha de 2 formas: por e-mail ou SMS. Basta preencher um dos campos abaixo e enviar. Você deve receber um e-mail ou SMS com o código de confirmação.</p>
                                <div className="registerInputs">                                    
                                    <TextField id="standard-basic" className="mailInput mt-3" label="E-MAIL"/>
                                    <TextField id="standard-basic" className="whatsInput mt-3" label="WHATSAPP"/>    
                                </div>
                                <Link to='/newpassword'><button type="submit" className="submitRegister mt-5">enviar</button></Link>
                            </div>
                        </div>
                    </div>
                    <Info/>
                </div>
            </div>
        );
    }
}

export default ForgotPassword;